import React, { useState, useEffect } from "react";
import { Col, FormGroup, UncontrolledTooltip } from "reactstrap";
import Swal from "sweetalert2";
import TarjetaExperiencia from "./TarjetaExperiencia";
import {
  getPerfil,
  editExpProf,
  getCategorias,
  deleteExpProf,
  getDataDelExp,
} from "../../requests/req_perfil";
import { notifica, show_ldr, months } from "../../requests/utils";
import { ButtonAdd, Label, SpanRequired } from "./styled.jsx";
import "../../styles/forms.css";
import { getMotivosSalida } from "../../requests/CatalogosGenerales";
import { postInsertarExperienciaProfesional } from "../../requests/PerfilCandidato";

const FrmExperiencia = ({ datos, handleUpdate }) => {
  const [dataExperience, setDataExperience] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [formValues, setFormValues] = useState({
    idCandidato: 0,
    idExperiencia: 0,
    Empresa: "",
    Cargo: "",
    idCategoria: 0,
    mesInicio: "00",
    anioInicio: null,
    anioMesInicio: "",
    mesFin: "00",
    anioFin: null,
    anioMesFin: "",
    SueldoPercibido: "",
    IdEmpleoActual: false,
    FuncionesCargo: "",
    idMotivoSalida: 0,
    Observaciones: "",
    constanciaLaboral: false,
  });
  const [categories, setCategories] = useState([]);
  const [motivosSalida, setMotivosSalida] = useState([]);
  const [years, setYears] = useState([]);

  useEffect(() => {
    setDataExperience(datos);
  }, []);

  useEffect(() => {
    loadYears();
  }, []);

  useEffect(() => {
    getCategorias((x) => {
      x.unshift({ valor: 0, descripcion: "Selecciona..." });
      setCategories(
        x.map((e) => {
          return { id: e.valor, value: e.descripcion };
        })
      );
    });
  }, []);

  useEffect(() => {
    getMotivosSalida().then((x) => {
      setMotivosSalida(x);
    });
  }, []);

  const loadYears = () => {
    let year = new Date().getFullYear();
    let yearList = [];
    for (let i = 0; i <= 100; i++) {
      yearList.push({ id: year - i, value: year - i });
    }
    setYears(yearList);
  };

  const selectHandler = (e) => {
    if (e.itemData === null) {
      SetFormValuesEmpty();
    } else {
      let item = e.itemData;
      setFormValues(item);
    }
    setEditMode(true);
  };

  const saveHandler = (e) => {
    if (!validaFields()) return;
    let item = formValues;
    if (item.IdEmpleoActual) {
      item.anioMesFin = null;
    }
    var candidato = getDataDelExp(item.idExperiencia);
    item.idCandidato = candidato.idCandidato;
    if (item.idExperiencia === 0) {
      show_ldr(true);
      if (item.idMotivoSalida === 0) {
        item.idMotivoSalida = null;
      }

      postInsertarExperienciaProfesional({
        ...item,
        constancia: item.constanciaLaboral,
      }).then((res) => {
        handleUpdate && handleUpdate();
        reloadList();
        show_ldr(false);
      });
    } else {
      item.observaciones = item.Observaciones;
      editExpProf(item, (exp) => {
        handleUpdate && handleUpdate();
        reloadList();
      });
    }
    setEditMode(false);
    SetFormValuesEmpty();
  };

  const SetFormValuesEmpty = (e) => {
    setFormValues({
      idCandidato: 0,
      idExperiencia: 0,
      Empresa: "",
      Cargo: "",
      idCategoria: 0,
      mesInicio: "00",
      anioInicio: new Date().getFullYear(),
      anioMesInicio: "",
      mesFin: "00",
      anioFin: new Date().getFullYear(),
      anioMesFin: "",
      SueldoPercibido: "",
      IdEmpleoActual: false,
      FuncionesCargo: "",
      idMotivoSalida: 0,
      Observaciones: "",
      constanciaLaboral: false,
    });
  };

  const reloadList = () => {
    getPerfil((res) => {
      if (res) {
        setDataExperience(res.tabla5);
      }
    });
  };

  const validaFields = () => {
    let i = 0;
    i += onChangeDate(null);

    let idCategoria = formValues.idCategoria;
    if (idCategoria === "0" || idCategoria === 0 || idCategoria == null) {
      notifica("warning", "Debe de indicar una categoria", "Alerta!");
      i++;
    }
    let empresa = formValues.Empresa;
    if (empresa === "" || empresa == null) {
      notifica("warning", "Debe de indicar el nombre de la empresa", "Alerta!");
      i++;
    }
    let cargo = formValues.Cargo;
    if (cargo === "" || cargo == null) {
      notifica("warning", "Debe de indicar el cargo", "Alerta!");
      i++;
    }
    let mesInicio = formValues.mesInicio;
    if (mesInicio === "00" || mesInicio === null || mesInicio === "null") {
      notifica("warning", "Debe de indicar la fecha de Inicio", "Alerta!");
      i++;
    }
    let anioInicio = formValues.anioInicio;
    if (anioInicio === 0 || anioInicio === null) {
      notifica("warning", "Debe de indicar la fecha de Inicio", "Alerta!");
      i++;
    }
    let IdEmpleoActual = formValues.IdEmpleoActual,
      mesFin = formValues.mesFin,
      anioFin = formValues.anioFin;
    if (!IdEmpleoActual) {
      if (mesFin === "00" || mesFin === null || mesFin === "null") {
        notifica("warning", "Debe de indicar la fecha de Termino", "Alerta!");
        i++;
      }
      if (anioFin === 0 || anioFin === null) {
        notifica("warning", "Debe de indicar la fecha de Termino", "Alerta!");
        i++;
      }
    }
    let sueldo = formValues.SueldoPercibido;
    if (sueldo === "0" || sueldo === "" || sueldo == null) {
      notifica("warning", "Debe de indicar el sueldo", "Alerta!");
      i++;
    }
    let funciones = formValues.FuncionesCargo;
    if (funciones === "" || funciones == null) {
      notifica("warning", "Debe indicar las funciones", "Alerta!");
      i++;
    }

    if (i > 0) return false;
    else return true;
  };

  const deleteHandler = (e) => {
    Swal.fire({
      title: "¿Estas seguro que deseas eliminar?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
    }).then((result) => {
      if (result.value) {
        if (e.itemData.idExperiencia === null) return false;
        var item = getDataDelExp(e.itemData.idExperiencia);
        deleteExpProf(item, (x) => {
          handleUpdate && handleUpdate();
          reloadList();
        });
      }
    });
  };

  const valueChange = (e) => {
    let id = e.target.id;
    let value = e.target.value;
    if (id === "IdEmpleoActual") {
      value = e.target.checked;
    }
    if (id === "constanciaLaboral") {
      value = e.target.checked;
    }
    let values = formValues;
    if (id === "IdEmpleoActual" && value) {
      values = { ...values, idMotivoSalida: 0, Observaciones: "" };
    }
    if (id === "idMotivoSalida" && value !== "4" && value !== 4) {
      values = { ...values, Observaciones: "" };
    }
    setFormValues({ ...values, [id]: value });
  };

  const onChangeDate = (e) => {
    let values = { ...formValues };
    if (e !== null) {
      let id = e.target.id;
      let value = e.target.value;
      values = { ...formValues, [id]: value };
    }
    let mesInicio = values.mesInicio;
    let anioInicio = values.anioInicio;
    let mesFin = values.mesFin;
    let anioFin = values.anioFin;
    if (
      mesInicio === "null" ||
      anioInicio === "null" ||
      mesFin === "null" ||
      anioFin === "null"
    ) {
      return 0;
    }
    let fechaInicio = new Date(parseInt(anioInicio), parseInt(mesInicio), 1);
    let fechaFin = new Date(parseInt(anioFin), parseInt(mesFin), 1);
    setFormValues({
      ...values,
      anioMesInicio: `${mesInicio}-${anioInicio}`,
      anioMesFin: `${mesFin}-${anioFin}`,
    });
    if (!values.IdEmpleoActual) {
      if (fechaInicio >= fechaFin) {
        notifica("warning", "Debe ingresar fechas validas", "Alerta!");
        return 1;
      }
    }
    return 0;
  };

  return (
    <div className="APL_Frm_dv">
      <FormGroup
        className={`dv_Form_New_Edit ${editMode ? "" : "Hide_All"}`}
        row
      >
        <Col sm={2} md={2} lg={2}>
          <Label>
            Empresa:<SpanRequired>*</SpanRequired>
          </Label>
        </Col>
        <Col sm={4} md={4} lg={4}>
          <input
            id="idExperiencia"
            type="hidden"
            className="frm frmExpPr"
            value={formValues.idExperiencia}
          />
          <input
            id="Empresa"
            type="text"
            className="frm frmExpPr"
            value={formValues.Empresa}
            onChange={(e) => valueChange(e)}
          />
        </Col>
        <Col sm={2} md={2} lg={2}></Col>
        <Col sm={4} md={4} lg={4}></Col>
        <Col sm={2} md={2} lg={2}>
          <Label>
            Cargo:<SpanRequired>*</SpanRequired>
          </Label>
        </Col>
        <Col sm={4} md={4} lg={4}>
          <input
            id="Cargo"
            type="text"
            className="frm frmExpPr"
            value={formValues.Cargo}
            onChange={(e) => valueChange(e)}
          />
        </Col>
        <Col sm={2} md={2} lg={2}>
          <Label>
            Categoría:<SpanRequired>*</SpanRequired>
          </Label>
        </Col>
        <Col sm={4} md={4} lg={4}>
          <select
            id="idCategoria"
            className="frm frmExpPr"
            value={formValues.idCategoria}
            onChange={(e) => valueChange(e)}
          >
            {categories.map((e, index) => {
              return (
                <option value={e.id} key={index}>
                  {e.value}
                </option>
              );
            })}
          </select>
        </Col>
        <Col sm={2} md={2} lg={2}>
          <Label>
            Fecha Inicio:<SpanRequired>*</SpanRequired>
          </Label>
        </Col>
        <Col sm={4} md={4} lg={4}>
          <select
            id="mesInicio"
            className="frm frm_sml frmExpPr"
            value={formValues.mesInicio}
            onChange={(e) => onChangeDate(e)}
          >
            {months.map((e, index) => {
              return (
                <option value={e.id} key={index}>
                  {e.value}
                </option>
              );
            })}
          </select>
          <select
            id="anioInicio"
            className="frm frm_sml frmExpPr"
            value={formValues.anioInicio}
            onChange={(e) => onChangeDate(e)}
          >
            {years.map((e, index) => {
              return (
                <option value={e.id} key={index}>
                  {e.value}
                </option>
              );
            })}
          </select>
        </Col>
        <Col sm={2} md={2} lg={2}>
          <Label className={`${formValues.IdEmpleoActual ? "Hide_Half" : ""}`}>
            Fecha Fin:
          </Label>
        </Col>
        <Col
          sm={4}
          md={4}
          lg={4}
          className={`${formValues.IdEmpleoActual ? "Hide_Half" : ""}`}
        >
          <select
            id="mesFin"
            className="frm frm_sml frmExpPr"
            value={formValues.mesFin}
            onChange={(e) => onChangeDate(e)}
          >
            {months.map((e, index) => {
              return (
                <option value={e.id} key={index}>
                  {e.value}
                </option>
              );
            })}
          </select>
          <select
            id="anioFin"
            className="frm frm_sml frmExpPr"
            value={formValues.anioFin}
            onChange={(e) => onChangeDate(e)}
          >
            {years.map((e, index) => {
              return (
                <option value={e.id} key={index}>
                  {e.value}
                </option>
              );
            })}
          </select>
        </Col>
        <Col sm={2} md={2} lg={2}>
          <Label>
            Sueldo percibido:<SpanRequired>*</SpanRequired>
          </Label>
        </Col>
        <Col sm={4} md={4} lg={4} className="row" style={{ marginLeft: "4px" }}>
          <div className="col-md-1">$</div>
          <div className="col-md-7" style={{ paddingRight: "0%" }}>
            <input
              id="SueldoPercibido"
              type="number"
              className="frm frmExpPr"
              value={formValues.SueldoPercibido}
              onChange={(e) => valueChange(e)}
            />
          </div>
          <div className="col-md-1">MXN</div>
        </Col>
        <Col sm={3} md={3} lg={3}>
          <Label>¿Empleo Actual?</Label>
        </Col>
        <Col sm={3} md={3} lg={3}>
          <label className="switch">
            <input
              id="IdEmpleoActual"
              type="checkbox"
              className="fctlg frmExpPr"
              checked={formValues.IdEmpleoActual}
              onChange={(e) => valueChange(e)}
            />
            <span className="slider round" />
          </label>
        </Col>
        <Col sm={3} md={3} lg={3}>
          <Label>
            Funciones del cargo:<SpanRequired>*</SpanRequired>
          </Label>
        </Col>
        <Col sm={9} md={9} lg={9}>
          <textarea
            id="FuncionesCargo"
            rows="4"
            cols="50"
            maxLength="1500"
            className={"frm frmExpPr"}
            value={formValues.FuncionesCargo}
            onKeyDown={(e) => {
              if (e.target.value.length >= 1500) {
                notifica(
                  "warning",
                  "Este campo tiene un limite máximo de caracteres de 1500",
                  "Alerta!"
                );
              }
            }}
            onChange={(e) => {
              if (e.target.value.length >= 1500) {
                notifica(
                  "warning",
                  "Este campo tiene un limite máximo de caracteres de 1500, el texto se truncara al limite definido",
                  "Alerta!"
                );
              }
              valueChange(e);
            }}
          />
        </Col>
        <Col sm={2} md={2} lg={2}>
          <label
            className={`lbl_md ${formValues.IdEmpleoActual ? "Hide_Half" : ""}`}
          >
            Motivo Salida:
          </label>
        </Col>
        <Col sm={4} md={4} lg={4}>
          <select
            id="idMotivoSalida"
            className={`frm frmExpPr ${
              formValues.IdEmpleoActual ? "Hide_Half" : ""
            }`}
            value={motivosSalida.length > 0 ? formValues.idMotivoSalida : 0}
            onChange={(e) => valueChange(e)}
          >
            <option value="0">Selecciona...</option>
            {motivosSalida.map((item, index) => {
              return (
                <option value={item.value} key={index}>
                  {item.label}
                </option>
              );
            })}
          </select>
        </Col>
        <Col sm={6} md={6} lg={6}>
          <textarea
            id="Observaciones"
            rows="4"
            cols="50"
            maxLength="250"
            placeholder="Expecifica motivo de salida"
            className={`frm frmExpPr ${
              formValues.idMotivoSalida === 4 ||
              formValues.idMotivoSalida === "4"
                ? ""
                : "Hide_All"
            }`}
            value={formValues.Observaciones}
            onChange={(e) => valueChange(e)}
          />
        </Col>
        <Col sm={2} md={2} lg={2}>
          <label className="lbl_md" id="Ctcl">
            ¿Cuentas con constancia laboral?
          </label>
        </Col>
        <Col sm={10} md={10} lg={10}>
          <label className="switch">
            <input
              id="constanciaLaboral"
              type="checkbox"
              className="fctlg frmExpPr"
              checked={formValues.constanciaLaboral}
              onChange={(e) => valueChange(e)}
            />
            <span className="slider round" />
          </label>
        </Col>
      </FormGroup>

      <FormGroup row>
        <Col sm={9} md={9} lg={9} />
        <Col sm={3} md={3} lg={3}>
          <ButtonAdd
            outline
            color="success"
            className={editMode ? "Hide_All" : ""}
            id="btn_exp_add"
            onClick={(e) => selectHandler({ ...e, itemData: null })}
          >
            <img
              src={window.origin + "/images/icon_add_2.png"}
              className="img_edit"
              alt="Agregar"
            />
            Agregar Experiencia
          </ButtonAdd>

          <ButtonAdd
            outline
            color="info"
            className={editMode ? "" : "Hide_All"}
            alt="Guardar"
            id="img_sv_EP"
            onClick={(e) => saveHandler(e)}
          >
            <img
              src={window.origin + "/images/icon_save_2.png"}
              className="img_edit"
              alt="Guardar"
            />
            Guardar Cambios
          </ButtonAdd>

          <UncontrolledTooltip placement="right" target="img_sv_EP">
            Guardar Cambios
          </UncontrolledTooltip>
        </Col>
      </FormGroup>

      <TarjetaExperiencia
        data={dataExperience}
        editMode={editMode}
        selectHandler={selectHandler}
        deleteHandler={deleteHandler}
      />
    </div>
  );
};

export default FrmExperiencia;
